import React from 'react';
export function Footer() {
  return <footer className="w-full py-8 px-4 bg-alt border-t border-primary/10 text-center" data-id="element-116">
      <div className="max-w-4xl mx-auto" data-id="element-117">
        <h3 className="text-xl font-bold text-text-main tracking-widest uppercase mb-4" data-id="element-118">
          BIBLIOTECAS DIGITALES™
        </h3>

        <p className="text-text-muted mb-2" data-id="element-119">
          El sistema de recursos N°1 para emprendedores de e-commerce en
          español.
        </p>
        <p className="text-text-muted mb-8" data-id="element-120">
          Porque vender por Reels no debería costarte todos los domingos del
          año.
        </p>

        <div className="flex flex-col md:flex-row justify-center items-center gap-4 md:gap-8 text-sm text-text-muted mb-12" data-id="element-121">
          <a href="mailto:soportebibliotecasdigitales@gmail.com" className="hover:text-primary transition-colors" data-id="element-122">
            📧 soportebibliotecasdigitales@gmail.com
          </a>
          <span className="hidden md:inline" data-id="element-123">•</span>
          <a href="https://www.bibliotecasdigitales.store" target="_blank" rel="noopener noreferrer" className="hover:text-primary transition-colors" data-id="element-124">
            🌐 www.bibliotecasdigitales.store
          </a>
        </div>

        <p className="text-xs text-text-muted/60 mb-8" data-id="element-125">
          © Bibliotecas Digitales™ 2024 — Todos los derechos reservados.
          Prohibida la reproducción sin autorización expresa.
        </p>

        <p className="text-sm font-bold text-primary italic" data-id="element-126">
          💪 "El próximo Reel puede ser el que genera tu primera venta del día."
        </p>
      </div>
    </footer>;
}